import { useEffect } from 'react';

import ContentBox from 'layout/atoms/ContentBox';

import IllustrationPlan from 'assets/illustrations/empty-plan.webp';

export const EmptyState = () => {
    useEffect(() => {}, []);

    return (
        <ContentBox>
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}
            >
                <img
                    src={IllustrationPlan}
                    alt=""
                    style={{ maxWidth: '200px' }}
                />
                <h3
                    style={{
                        margin: '0 0 12px 0',
                        fontSize: '20px',
                        fontWeight: '600',
                        color: 'var(--text)',
                    }}
                >
                    Welcome to your workspace!
                </h3>
                <p
                    style={{
                        margin: '0 0 24px 0',
                        fontSize: '16px',
                        lineHeight: '1.5',
                        color: 'var(--text)',
                        opacity: 0.7,
                        maxWidth: '400px',
                    }}
                >
                    Organize your tasks into projects for better management and
                    focus. Projects help you group related work and track
                    progress effectively.
                </p>
                <div
                    style={{
                        fontSize: '14px',
                        color: 'var(--text)',
                        opacity: 0.6,
                        fontWeight: '500',
                    }}
                >
                    👇 Create your first project below
                </div>
            </div>
        </ContentBox>
    );
};

export default EmptyState;
